export default function EighthPage() {
  return (
    <>
      <div className="containerWithoutBg">
        <div className="footerContainerWithoutBg">
          <div
            style={{ minWidth: "500px", maxWidth: "650px", fontSize: "30px" }}>
            <h2>
              Experience remarkable WordPress products with a new level of
              power, beauty, and human-centered designs.
            </h2>
          </div>
          <div>
            <h3 style={{ fontSize: "20px", color: "#9FA0A1" }}>Jump to</h3>
            <p style={{ fontSize: "20px", color: "#2042B6" }}>
              <a href="./about"> About us</a> <br />
              <a href="./portfolio">Portfolio</a>
              <br />
              <a href="./news">News</a>
              <br />
              <a href="./stories">Stories</a>
              <br />
              <a href="./jobs">Jobs</a>
              <br />
              <a href="./aboaut">About Us</a>
            </p>
          </div>
          <div className="addresses">
            <div className="address">
              <h2>Cambridge</h2>
              <p>
                70728 Yost Burg, <br />
                North Magdaleneview
                <br /> UT 97952-2814
              </p>
              <div className="lineBreak1" />{" "}
            </div>

            <div className="address">
              <h2>London</h2>
              <p>
                Suite 292 903 Stehr Streets, <br />
                Langworthtown, SC 94577-9465
              </p>
              <div className="lineBreak1" />{" "}
            </div>

            <div className="address">
              <h2>Messina Sans</h2>
              <p>
                19837 Gilberto Lodge, <br />
                Lake Kendallville, <br />
                Colorado - 97392, Bhutan
              </p>

              <div className="lineBreak1" />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="footerIcon">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M27.5 2.48529V25.5147C27.5 26.0412 27.2908 26.5462 26.9185 26.9185C26.5462 27.2908 26.0412 27.5 25.5147 27.5H2.48529C1.95876 27.5 1.45379 27.2908 1.08148 26.9185C0.709164 26.5462 0.5 26.0412 0.5 25.5147L0.5 2.48529C0.5 1.95876 0.709164 1.45379 1.08148 1.08148C1.45379 0.709164 1.95876 0.5 2.48529 0.5L25.5147 0.5C26.0412 0.5 26.5462 0.709164 26.9185 1.08148C27.2908 1.45379 27.5 1.95876 27.5 2.48529ZM8.44118 10.8235H4.47059V23.5294H8.44118V10.8235ZM8.79853 6.45588C8.80062 6.15554 8.74354 5.85773 8.63053 5.57945C8.51752 5.30117 8.35081 5.04787 8.13991 4.83402C7.92901 4.62017 7.67806 4.44996 7.40137 4.3331C7.12469 4.21624 6.8277 4.15502 6.52735 4.15294H6.45588C5.8451 4.15294 5.25934 4.39557 4.82746 4.82746C4.39557 5.25934 4.15294 5.8451 4.15294 6.45588C4.15294 7.06666 4.39557 7.65242 4.82746 8.08431C5.25934 8.51619 5.8451 8.75882 6.45588 8.75882C6.75625 8.76621 7.05512 8.71435 7.33543 8.60619C7.61575 8.49803 7.872 8.3357 8.08955 8.12847C8.3071 7.92124 8.48169 7.67318 8.60334 7.39845C8.72499 7.12372 8.79132 6.82772 8.79853 6.52735V6.45588ZM23.5294 15.8106C23.5294 11.9909 21.0994 10.5059 18.6853 10.5059C17.8949 10.4663 17.1079 10.6347 16.4028 10.9942C15.6977 11.3537 15.0993 11.8917 14.6671 12.5547H14.5559V10.8235H10.8235V23.5294H14.7941V16.7715C14.7367 16.0793 14.9547 15.3925 15.4008 14.8602C15.8469 14.3279 16.485 13.9931 17.1765 13.9285H17.3274C18.59 13.9285 19.5271 14.7226 19.5271 16.7238V23.5294H23.4976L23.5294 15.8106Z"
                      fill="#9FA0A2"
                    />
                  </svg>
                </div>
                <div className="footerIcon">
                  <svg
                    width="30"
                    height="26"
                    viewBox="0 0 30 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M26.9287 6.88009C26.947 7.14457 26.947 7.40904 26.947 7.67595C26.947 15.8088 20.7556 25.1884 9.43449 25.1884V25.1836C6.09019 25.1884 2.81536 24.2305 0 22.4243C0.486289 22.4828 0.975015 22.512 1.46496 22.5132C4.23644 22.5157 6.9287 21.5858 9.10908 19.8734C6.47532 19.8234 4.16575 18.1062 3.35893 15.5992C4.28154 15.7771 5.23218 15.7405 6.13772 15.4931C3.2663 14.913 1.20049 12.3901 1.20049 9.46023C1.20049 9.43341 1.20049 9.40782 1.20049 9.38223C2.05606 9.85877 3.01402 10.1232 3.99391 10.1525C1.28946 8.34505 0.45582 4.74725 2.08897 1.93433C5.21389 5.77955 9.8245 8.11714 14.7739 8.36455C14.2779 6.22683 14.9555 3.98674 16.5545 2.48399C19.0335 0.153708 22.9324 0.273147 25.2626 2.7509C26.6411 2.47912 27.9622 1.97333 29.1712 1.25669C28.7118 2.68143 27.7502 3.89167 26.4656 4.66072C27.6856 4.5169 28.8775 4.19027 30 3.69179C29.1737 4.93006 28.1328 6.00867 26.9287 6.88009Z"
                      fill="#9FA0A2"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ textAlign: "left", maxWidth: "500px" }}>
          <p>©2024 Terms of Use Privacy Policy</p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
            mollitia, molestiae quas vel sint commodi repudiandae consequuntur
            voluptatum laborum numquam blanditiis harum quisquam eius sed odit
            fugiat iusto fuga praesentium optio, eaque rerum! Provident
            similique accusantium nemo autem. Veritatis obcaecati tenetur iure
            eius earum ut molestias architecto voluptate aliquam nihil, eveniet
            aliquid culpa officia aut! Impedit sit sunt quaerat.
          </p>
        </div>
      </div>
    </>
  );
}
